module.exports = __webpack_public_path__ + "img/meeting.5d1ce5ab.svg";